import { PriceArrowUpUrl, PriceArrowDownUrl } from '../../Svg'

const priceArrows = {
  up: PriceArrowUpUrl,
  down: PriceArrowDownUrl
}

export default priceArrows
